import { styled, TextField, type TextFieldProps } from "~/common/mui";

export type SearchInputGroupSelectProps = Omit<TextFieldProps, "variant" | "select">;

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
  },
});

export const SearchInputGroupSelect = (props: SearchInputGroupSelectProps) => {
  return <StyledTextField variant="outlined" select {...props} />;
};
